module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBold.4ba0ced.woff2";